import * as Hub from "@dux/hub";
import { filter } from "rxjs/operators";
import { ofType } from "redux-observable";

export function ofHubEvent(id) {
  return (action$) =>
    action$.pipe(
      ofType(Hub.HUB_EVENT),
      filter(({ payload }) => {
        return payload.id === id;
      })
    );
}

export function ofHubEventPrefix(id) {
  return (action$) =>
    action$.pipe(
      ofType(Hub.HUB_EVENT),
      filter(({ payload }) => {
        return payload.id.startsWith(id);
      })
    );
}

const hubEmitterState = { subscriptions: [] };

export function hubSubscribe(prefix, callback, filter) {
  hubEmitterState.subscriptions = [
    ...hubEmitterState.subscriptions,
    { prefix, callback, filter },
  ];
}

export function hubUnsubscribe(prefix, callback) {
  hubEmitterState.subscriptions = hubEmitterState.subscriptions.filter(
    (x) => !(x.prefix === prefix && x.callback === callback)
  );
}

export function hubUnsubscribeAll(prefix) {
  hubEmitterState.subscriptions = hubEmitterState.subscriptions.filter(
    (x) => !(x.prefix === prefix)
  );
}

export function hubEmit(prefix, message) {
  hubEmitterState.subscriptions.forEach((x) => {
    if (x.prefix === prefix) {
      if (!x.filter || x.filter(message)) {
        x.callback(message);
      }
    }
  });
}
